module.exports = __webpack_public_path__ + "img/a3.ce326701.jpg";